export default {
  label: {
    series: {
      engagedContacts: 'Contatos com interação',
      nonEngagedContacts: 'Contatos que não responderam',
    },
  },
};
